import { z } from "zod";

export enum ReimburseUnloading {
	Select = 0,
	Yes = 1,
	No = 2,
	Sometimes = 3,
}

export const reimburseUnloadingOptions = [
	{ text: "No", value: ReimburseUnloading.No },
	{ text: "Yes", value: ReimburseUnloading.Yes },
	{ text: "Sometimes", value: ReimburseUnloading.Sometimes },
];

export const booleanDropdownOptions = [
	{ text: "Yes", value: true },
	{ text: "No", value: false },
];

export const billingInformationSchema = z.object({
	companyName: z.string(),
	mailingStreetAdd: z.string(),
	mailingCityAdd: z.string(),
	mailingStateAdd: z.string(),
	mailingZipAdd: z.string(),
	billingStreetAdd: z.string(),
	billingCityAdd: z.string(),
	billingStateAdd: z.string(),
	billingZipAdd: z.string(),
	invoicedVia: z.string(),
	invoicedViaEmail: z.string(),
	invoicedViaFax: z.string(),
	requireBOL: z.boolean(),
	requireLoadTenders: z.boolean(),
	reimburseUnloading: z.nativeEnum(ReimburseUnloading),
	miscRequirements: z.string(),
});

export type BillingInformation = z.infer<typeof billingInformationSchema>;

export type UpdateBillingInformationBody = {
	email: string;
} & BillingInformation;
